const getNcbiClinvar2Data = (state) => {
  return state.variantResult && state.variantResult.ncbi_clinvar2;
};

export { getNcbiClinvar2Data };
